const initialState = {
  proposals: [],
  clients: [],
  step: "selectProposal",
  selectedProposal: null
};
const proposalReducer = (state, action) => {
  switch (action.type) {
    case "SET_PROPOSALS":
      return {
        ...state,
        proposals: action.payload
      };
    case "SET_CLIENTS":
      return {
        ...state,
        clients: action.payload
      };
    case "SET_SELECTED_PROPOSAL":
      return {
        ...state,
        selectedProposal: action.payload
      };
    case "SET_STEP":
      return {
        ...state,
        step: action.payload
      };
    default:
      return state;
  }
};

export { initialState, proposalReducer };
//# sourceMappingURL=proposalReducer.esm.js.map
